import MoneyFormatter from "./money-formatter";

export default MoneyFormatter;
